export const PartnerStatisticsPaths = {
	Index: {
		route: "/partners/statistics",
		path: "/partners/statistics",
	},
};
